export default __webpack_public_path__ + "static/media/Register-image.5585bd90.png";